import * as buttons from 'smg/buttons';
import { UpdateCurrentUser } from 'smg/customer-api/currentuser';
import * as session from 'smg/customer-api/session';
import * as errors from 'smg/errors';
import { Phone } from 'smg/phone';
import * as template from 'smg/template';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const formParent = document.querySelector('#form-parent') as HTMLElement;
    const form = document.querySelector('#account-settings-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const submit = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const formSpinner = document.querySelector('#form-spinner') as HTMLElement;

    const userID = document.querySelector('#user-id') as HTMLElement;

    const user = await session.Session().then(s => s.user);

    userID.textContent = user.id ?? '';

    formSpinner.parentElement?.removeChild(formSpinner);
    formParent.classList.remove('d-none');

    const firstName = document.querySelector('#first-name') as HTMLInputElement;
    const lastName = document.querySelector('#last-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const phoneEl = document.querySelector('#phone') as HTMLInputElement;

    firstName.value = user.firstName ?? '';
    lastName.value = user.lastName ?? '';
    company.value = user.company ?? '';
    email.value = user.emailAddress.email;
    phoneEl.value = user.phoneNumber.phone;

    if (firstName.value) {
        firstName.required = true;
    }
    if (lastName.value) {
        lastName.required = true;
    }
    if (phoneEl.value) {
        phoneEl.required = true;
    }

    const p = new Phone(phoneEl);

    const alertParent = document.querySelector('#alert-parent') as HTMLElement;

    form.addEventListener('submit', async e => {
        e.preventDefault();

        fieldset.disabled = true;
        buttons.Start(submit);

        UpdateCurrentUser({
            firstName: firstName.value,
            lastName: lastName.value,
            company: company.value,
            email: email.value,
            phone: await p.format(),
        }).then(() => {
            session.ClearCache();
            alertParent.appendChild(template.Clone('#update-success-template'));
        }).catch(err => errors.ShowError(err, form)).
            finally(() => {
                fieldset.disabled = false;
                buttons.Stop(submit);
            });
    });
}